module.exports = __webpack_public_path__ + "static/media/audience1st.429baa88.png";